module.exports = __webpack_public_path__ + "static/media/phoneIcon.6fac6983.svg";